export default __webpack_public_path__ + "static/media/sale.53ff5e36.svg";